import { useCallback, useEffect, useRef } from "react";

declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
  }
}

const SCRIPT_ID = "instagram-embed-script";
const SCRIPT_SRC = "https://www.instagram.com/embed.js";

export function useInstagramEmbed() {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) {
      scriptLoaded.current = true;
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      scriptLoaded.current = true;
    };
    document.body.appendChild(script);
  }, []);

  const processEmbeds = useCallback(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  return { processEmbeds };
}
